import dynamic from 'next/dynamic'
const Page = dynamic(() => import('../../components/templates/Page'), {
  ssr: true,
  loading: () => null
})
const Section = dynamic(() => import('../../components/elements/Section'), {
  ssr: true,
  loading: () => null
})
const Container = dynamic(() => import('../../components/elements/Container'), {
  ssr: true,
  loading: () => null
})
const Button = dynamic(() => import('../../components/elements/Section'), {
  ssr: true,
  loading: () => null
})
import styles from './styles.module.scss'
import headerTranslation from '/components/general/Header/headerTranslation'
import footerTranslation from '/components/general/Footer/footerTranslations'
import ctaTranslation from '/components/pages/home/CTA/ctaTranslations'
import cache from 'memory-cache'

export const getStaticProps = async () => {
  let headerDataTranslation = cache.get('headerTranslations')
  if (!headerDataTranslation) {
    headerDataTranslation = await headerTranslation()
    cache.put('headerTranslations', headerDataTranslation)
  }

  // caching for footer translations
  let footerDataTranslation = cache.get('footerTranslations')
  if (!footerDataTranslation) {
    footerDataTranslation = await footerTranslation()
    cache.put('footerTranslations', footerDataTranslation)
  }

  // caching for CTA footer translations
  let ctaDataTranslation = cache.get('ctaTranslations')
  if (!ctaDataTranslation) {
    ctaDataTranslation = await ctaTranslation()
    cache.put('ctaTranslations', ctaDataTranslation)
  }

  return {
    props: {
      headerTranslation: headerDataTranslation,
      footerTranslation: footerDataTranslation,
      ctaTranslation: ctaDataTranslation
    },
    revalidate: 300
  }
}

const FourOhFour = ({
  headerTranslation,
  footerTranslation,
  ctaTranslation
}) => (
  <Page
    ctaTranslation={ctaTranslation}
    headerTranslation={headerTranslation}
    footerTranslation={footerTranslation}
    meta={{
      title: "404 - Error Page | St. Martin Sotheby's Realty",
      description: "404 - Error Page | St. Martin Sotheby's Realty"
    }}
  >
    <Section variant={['center']}>
      <Container>
        <div className={styles.content}>
          <h1 className={styles.content__title}>Sorry, no page found</h1>

          <div className={styles.content__separator}></div>

          <span className={styles.content__description}>
            WE COULDN’T FIND WHAT YOU’RE LOOKING FOR
          </span>

          <Button href="/vacation-rentals" arrow={false}>
            browse our properties
          </Button>
        </div>
      </Container>
    </Section>
  </Page>
)

export default FourOhFour
